/**
 * ElementDialog 相关的常量配置
 */

/**
 * 输入框最大长度
 */
export const MAX_INPUT_LENGTH = 30;

/**
 * 文本域输入最大长度配置
 */
export const MAX_TEXTAREA_INPUT_LENGTH = {
  /** 风格描述最大长度 */
  style: 60,
  /** 描述文本最大长度 */
  description: 1200,
} as const;
